import React from 'react';
import { partners } from '../data/mock';

const PartnersSection = () => {
  // Duplicate logos for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners, ...partners];

  return (
    <section id="partners" className="py-20 bg-white relative overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-50/30 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Unsere Partner
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Wir arbeiten mit allen führenden Schweizer Versicherungsgesellschaften zusammen
          </p>
        </div>

        {/* Infinite Scrolling Logo Carousel */}
        <div className="relative">
          {/* Gradient fade on edges */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10"></div>

          <div className="overflow-hidden py-8">
            <div className="flex animate-scroll-infinite">
              {duplicatedPartners.map((partner, index) => (
                <div
                  key={`${partner.id}-${index}`}
                  className="flex-shrink-0 mx-8 flex items-center justify-center"
                  style={{ width: '180px' }}
                >
                  <img
                    src={partner.logo}
                    alt={`${partner.name} Logo`}
                    className="h-16 w-auto object-contain grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;